import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SubmissionStatisticDashboard = ({ base_url }) => {
  const [users, setUsers] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  useEffect(() => {
    axios.get(`${base_url}/users`)
      .then(response => setUsers(response.data))
      .catch(error => console.error('Error fetching users:', error));
  }, [base_url]);

  useEffect(() => {
    axios.get(`${base_url}/submissions`)
      .then(response => setSubmissions(response.data))
      .catch(error => console.error('Error fetching submissions:', error));
  }, [base_url]);

  const filteredSubmissions = selectedUser
    ? submissions.filter(sub => sub.user_id === parseInt(selectedUser))
    : submissions;

  const formattedData = filteredSubmissions.map(sub => ({
    x: new Date(sub.submission_date).getTime(),
    y: sub.result,
    exam: `Exam ${sub.exam_id}`,
    student_id: sub.user_id,
    submission_date: new Date(sub.submission_date).toLocaleString() // Format the date properly
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white shadow-lg p-3 border rounded-md text-sm">
          <p className="font-semibold">User ID: {data.student_id}</p>
          <p>Exam: {data.exam}</p>
          <p>Submission Date: {data.submission_date}</p>
          <p>Result: {data.y}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-xl mt-10">
      <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Submission Statistic Board</h1>
      <div className="mb-6">
        <label className="block mb-2 text-lg font-medium text-gray-700">Select User:</label>
        <select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
        >
          <option value="">-- All Students --</option>
          {users.map(user => (
            <option key={user.user_id} value={user.user_id}>
              {user.full_name}
            </option>
          ))}
        </select>
      </div>
      <div className="w-full h-96">
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              type="number" 
              dataKey="x" 
              domain={['auto', 'auto']} 
              name="Submission Date" 
              tickFormatter={(tick) => new Date(tick).toLocaleDateString()} 
            />
            <YAxis type="number" dataKey="y" name="Result" domain={[0, 100]} />
            <Tooltip content={<CustomTooltip />} cursor={{ strokeDasharray: '3 3' }} />
            <Scatter name="Submissions" data={formattedData} fill="#8884d8" />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SubmissionStatisticDashboard;
